import React from 'react'

import { Navigate, useSearchParams } from 'react-router-dom'

import { CasinoUiProvider } from '../../context/CasinoUiContext'

import LotusCasinoShell from '../../components/LotusCasinoShell/LotusCasinoShell'

import CasinoOther from './casinoOther'

import '../../components/LotusCasinoShell/LotusCasinoShell.css'

/** Legacy `/casino-int/:type?category=` provider pages — redirect bare URLs to lobby. */

const LotusCasinoLaunchBridge: React.FC = () => (
  <div className="lotus-casino-launch-bridge" aria-hidden>
    <CasinoOther lotusUiMode />
  </div>
)

const LotusCasinoPage = () => {
  const [searchParams] = useSearchParams()

  const category = searchParams.get('category')
  const gameType = searchParams.get('gameType')

  if (!category && !gameType) {
    return <Navigate to="/casino-int/tab/1" replace />
  }

  if (gameType && !category) {
    return (
      <CasinoUiProvider>
        <div className="lotus-casino-launch-root">
          <LotusCasinoShell />
          <LotusCasinoLaunchBridge />
        </div>
      </CasinoUiProvider>
    )
  }

  return (
    <CasinoUiProvider>
      <div className="lotus-casino-launch-root">
        <LotusCasinoShell />
        <LotusCasinoLaunchBridge />
      </div>
    </CasinoUiProvider>
  )
}

export default LotusCasinoPage
